<template>
<div class="row">
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-lightborder table-striped table-hover">
      <thead>
        <tr>
          <th class="text-center" >Tienda</th>
          <th class="text-center" >Usuario</th>
          <th class="text-center" >Creado Hace</th>
          <th class="text-center" >Fecha</th>
          <th class="text-center">Proveedor</th>
          <th class="text-center">Codigo Proveedor</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="rowClick(current)">
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.usuario.name }}</td>
          <td>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td>{{ current.fecha }}</td>
          <td>{{ current.proveedor.nombre }}</td>
          <td class="text-center" >{{ current.proveedor.codigo }}</td>
          <td class="text-center">
            <div data-title="Activo" data-toggle="tooltip" v-html="current.estado_str"></div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="onPageChange" />
  </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import OrdenCompraService from "@/services/compras/OrdenCompraService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: []
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "ordencompra/orden_compras"
    })
  },
  mounted() {
    this.$store.dispatch("ordencompra/fetch");
  },
  methods: {

    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cxp-cargo-nuevo",
        params: { orden_compra:current.id },
      });
      document.location.reload();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("ordencompra/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext
      });
    },
    irAEsconderModal(name, params) {
      if($('.modal').hasClass('show')){
        $('.modal').find('.close').click();
      }
      this.$router.push({
        name: name,
        params: params
      });
    },
    generar_entrada_compra(current) {
      /**
       * Genera una entrada de inventario basada en la orden de compra
       */
      let self = this;
      OrdenCompraService.generar_entrada_compra(current.id)
        .then(response => {
          Notifications.alert.confirm(
            "Entrada de prodcuto",
            "Ir a la Entrada Generada",
            "",
            function() {
              self.$router.push({
                name: "",
                params: { id: response.data.ent_compra }
              });
            }
          );
        })
        .catch(error => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  }
};
</script>
